module.exports = __webpack_public_path__ + "img/campanha-placeholder.9037bb3d.png";